import React from 'react';

import { pageHeadersList } from '@constants/pageTitles';
import { usePageTitle } from '@helpers/usePageTitle';
import { WithAccountWrapper } from '@hoc/WithAccountWrapper';
import { LocateProductTemplate } from '@templates/manageInventory/locateProduct/LocateProductTemplate';

export const LocateProductPage = () => {
    usePageTitle(pageHeadersList.MANAGE_INVENTORY.LOCATE_PRODUCT);

    return (
        <WithAccountWrapper>
            <LocateProductTemplate />
        </WithAccountWrapper>
    );
};
